import { Table } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { type FiservPaymentModuleSpecsFragment } from '../../../../api/fragments/FiservPaymentModuleSpecs';
import FiservPaymentSettingActions from './FiservPaymentSettingActions';

export type FiservPaymentSettingsTableProps = {
    module: FiservPaymentModuleSpecsFragment;
};

export type PaymentSettingSpecs = FiservPaymentModuleSpecsFragment['paymentSettings'][number];

const FiservPaymentSettingsTable = ({ module }: FiservPaymentSettingsTableProps) => {
    const { t } = useTranslation(['fiservPaymentModuleDetails']);

    const renderActions = useCallback(
        (record: PaymentSettingSpecs) => <FiservPaymentSettingActions module={module} paymentSetting={record} />,
        [module]
    );

    return (
        <Table dataSource={module.paymentSettings} rowKey="id">
            <Table.Column
                key="displayName"
                dataIndex="displayName"
                title={t('fiservPaymentModuleDetails:paymentSettingsTable.columns.displayName')}
            />
            <Table.Column
                key="currency"
                dataIndex="currency"
                title={t('fiservPaymentModuleDetails:paymentSettingsTable.columns.currency')}
            />
            <Table.Column
                key="amount"
                dataIndex="amount"
                title={t('fiservPaymentModuleDetails:paymentSettingsTable.columns.amount')}
            />
            <Table.Column
                key="actions"
                align="center"
                render={renderActions}
                title={t('fiservPaymentModuleDetails:paymentSettingsTable.columns.actions')}
                width={100}
            />
        </Table>
    );
};

export default FiservPaymentSettingsTable;
